module.exports = __webpack_public_path__ + "static/media/i_item_like_off.c92072ff.png";